<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <user-edit-tab-social class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import UserEditTabAccount     from './UserEditTabAccount.vue'
import UserEditTabInformation from './UserEditTabInformation.vue'
import UserEditTabSocial      from './UserEditTabSocial.vue'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    UserEditTabAccount,
    UserEditTabInformation,
    UserEditTabSocial
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    async activeTab () {
      if (this.activeTab === 1) {
        localStorage.setItem('validate-count', 0)
        
        setTimeout(() => {
          const radios = document.querySelectorAll('[name="gender_id"]')
          
          for (const i of document.getElementsByName('gender_id')) {
            if (this.$store.state.userManagement.userProfile.gender_id === parseInt(i.value)) {
              i.checked = true
            }
          }
        }, 300)
        
      } else if (this.activeTab === 0) {
        localStorage.setItem('validate-count', 0)
      } else {
        localStorage.setItem('validate-count', 0)
      }
      // await this.fetch_user_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)
    }
  },
  mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Perfil`
  },
  methods: {
    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('userManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('userManagement/setUserProfile', res)
          this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) 
        })
    }
  },
  async created () {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    await this.fetch_user_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)
  }
}

</script>
